    <!-- Body Content-->
    <div class="pt-3 md:px-4 px-2 pb-8" aria-label="create-class-container">

      <form *ngIf="createClassForm" [formGroup]="createClassForm">

      <div class="flex align-items-center justify-content-between">
        <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1" aria-label="create-class-title">
          {{'SCHEDULE.CREATECLASS.SCHEDULE_CLASS' | translate}}
          <!-- <i class="fa fa-question-circle font-light text-xl text-600 cursor-pointer ml-2" pTooltip="This is a sample!"
            tooltipStyleClass="text-xs">
          </i> -->
          <a class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600" 
            href="https://guides.unifiedfitnessplatform.ai/showcase/cluii14f708qu4l525shk6sdt" 
            target="_blank"
            aria-label="help-guide-link"
            data-testid="help-guide-link">
            <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
            <span class="ml-2 hidden md:inline-block">Help Guide for {{'SCHEDULE.CREATECLASS.SCHEDULE_CLASS' | translate}}</span>
          </a>
        </h1>

        <button pButton pRipple type="button" icon="fa fa-plus" class="text-sm md:w-9rem" label="New Class Category" (click)="GoToClassType()" aria-label="add-new-class-button">
        </button>
      </div>

      <!-- Card -->
      <div class="shadow-2 border-round surface-0 text-sm mt-3 md:mt-4" aria-label="class-type-card">
        <!-- Grid -->
        <div class="grid px-3 py-2">

          <!-- Form Group -->
          <div class="col-12 md:col-6 lg:col-4 md:pr-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="class-type-label">{{'SCHEDULE.CREATECLASS.SELECTCLASS' | translate}}</label>

            <p-select [options]="classTypeList$ | async" optionLabel="name_primary_language"
              filterBy="name_primary_language" styleClass="w-full text-sm"
              placeholder="{{'SCHEDULE.CREATEAPPOINTMENT.SELECTWITHDOTS' | translate}}" formControlName="classType"
              (onChange)="SelectClassType($event)"
              aria-label="class-type-dropdown"
              >
              <ng-template pTemplate="selectedItem">
                <div *ngIf="selectedClassType" class="flex align-items-center text-sm">
                  <span class="text-{{selectedClassType.color}}-400">{{selectedClassType.name_primary_language}}</span>
                  <span *ngIf="selectedClassType.logo" class="{{selectedClassType.logo}} ml-3"></span>
                </div>
              </ng-template>
              <ng-template let-class pTemplate="item">
                <div class="flex align-items-center text-sm">
                  <span class="">{{class.name_primary_language}}</span>
                  <span *ngIf="class.logo" class="{{class.logo}} ml-3"></span>
                </div>
              </ng-template>
            </p-select>

            <app-error-msg *ngIf="ClassTypeFormControl.touched && ClassTypeFormControl.invalid"
              [errors]="ClassTypeFormControl.errors"
              [fieldLabel]="'SCHEDULE.CREATECLASS.LABL_SELECT_TYPE' | translate">
            </app-error-msg>

          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="col-12 md:col-6 lg:col-4 md:pl-4" *ngIf="showClssSubType | async">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" *ngIf="showClssSubType | async"
              aria-label="class-subtype-label">
              {{'SCHEDULE.VIEWAPPOINTMENT.SUBPURPOSE' | translate}}
            </label>
            <!-- For Desktop -->
            <div class="hidden md:flex p-buttonset" aria-label="class-subtype-buttons">
              <ng-container *ngFor="let subType of (classSubTypeList$ | async)">
                <button pButton pRipple
                  [ngClass]="selectedClassSubType! && selectedClassSubType === subType ? 'text-sm border-right-1 border-white border-1':'p-button-secondary text-sm border-right-1 border-white border-1'"
                  type="button" (click)="SelectClassSubType(subType)" [label]="subType.name_primary_language"
                  [attr.aria-label]="'class-subtype-button-' + subType.name_primary_language"
                  >
                </button>
              </ng-container>
            </div>
            <!-- For Desktop -->

            <!-- For Mobile -->
            <p-select [options]="classSubTypeList$ | async" formControlName="classSubType"
              optionLabel="name_primary_language" filterBy="name_primary_language" styleClass="w-full text-sm md:hidden"
              placeholder="{{'SCHEDULE.CREATEAPPOINTMENT.SELECTWITHDOTS' | translate}}" *ngIf="showClssSubType | async"
              (onChange)="SelectClassSubType($event)"
              aria-label="class-subtype-dropdown"
              >
              <ng-template pTemplate="selectedItem">
                <div *ngIf="selectedClassSubType" class="text-sm">{{selectedClassSubType.name_primary_language}}</div>
              </ng-template>
              <ng-template let-subClass pTemplate="item">
                <div class="text-sm">{{subClass.name_primary_language}}</div>
              </ng-template>
            </p-select>
            <!-- For Mobile -->
          </div>
          <!-- Form Group -->

        </div>
        <!-- Grid -->
      </div>
      <!-- Card -->
      <!-- Card -->
      <div class="shadow-2 border-round surface-0 text-sm mt-3" aria-label="class-schedule-card">

        <div class="p-3 border-bottom-1 border-300">
          <h3 class="text-sm font-normal mb-3" aria-label="repeating-class-title">{{'SCHEDULE.CREATECLASS.REPEATINGCLSTIME' | translate}}</h3>
          <p class="mb-0 flex text-600 text-xs md:text-sm">
            <i class="fa fa-info-circle cursor-pointer mr-2" pTooltip="{{'SCHEDULE.CREATECLASS.TIMEINFO' | translate}}"
              tooltipStyleClass="text-xs" tooltipStyleClass="text-xs" aria-label="time-info-icon"></i>
            {{'SCHEDULE.CREATECLASS.TIMEINFO' | translate}}
          </p>
        </div>

        <div class="grid my-0 px-4 py-2">
          <div class="col-12 md:col-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="start-time-label">{{'SCHEDULE.CREATECLASS.STARTTIMEINFO' | translate}}</label>
           
            <p-datepicker 
              inputId="calendar-timeonly" 
              styleClass="w-full"
              inputstyleClass="text-sm m-0 border-400 h-2rem border-round"
              formControlName="startTime"
              [hourFormat]="12"
              [placeholder]="'SCHEDULE.VIEWCLASS.SELECTTIME' | translate"
              [timeOnly]="true"
              aria-label="start-time-calendar"
              [min]="minimumDate"
               />

            <!-- <mbsc-datepicker cssClass="w-full"
              inputStyle="text-sm m-0 border-400 h-2rem border-round" [touchUi]="false"
              placeholder="{{'SCHEDULE.VIEWCLASS.SELECTTIME' | translate}}" [closeOnEsc]="true"
              [closeOnOverlayClick]="true" [themeVariant]="['light']" formControlName="startTime" [controls]="['time']" [min]="minimumDate"
              [options]="dateSelectionOptionFortime">
            </mbsc-datepicker> -->
            <app-error-msg *ngIf="StartTimeFormControl.touched && StartTimeFormControl.invalid"
              [errors]="StartTimeFormControl.errors"
              [fieldLabel]="'SCHEDULE.CREATEAPPOINTMENT.LBL_STARTTIME' | translate" >
            </app-error-msg>
          </div>

          <div class="col-12 md:col-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="start-date-label">{{'SCHEDULE.CREATECLASS.STARTDATEINFO' | translate}}</label>
            <p-datepicker 
             [minDate]="minimumDate" 
             [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate"
             styleClass="w-full"
             inputstyleClass="w-full text-sm m-0 border-400 h-2rem border-round"
             formControlName="startDate"
             aria-label="start-date-calendar"
             [min]="minimumDate"
             />
             
            <!-- <mbsc-datepicker cssClass="w-full"
              inputStyle="w-full text-sm m-0 border-400 h-2rem border-round" [touchUi]="false"
              placeholder="{{'SCHEDULE.VIEWCLASS.SELECTDATE' | translate}}" [closeOnEsc]="true"
              [closeOnOverlayClick]="true" formControlName="startDate" [themeVariant]="['light']" [controls]="['date']" [min]="minimumDate"
              [options]="dateSelectionOptionForDate">
            </mbsc-datepicker> -->
            <app-error-msg *ngIf="StartDateFormControl.touched && StartDateFormControl.invalid"
              [errors]="StartDateFormControl.errors"
              [fieldLabel]="'SCHEDULE.CREATEAPPOINTMENT.LBL_STARTDATE' | translate">
            </app-error-msg>
          </div>

          <div class="col-12 md:col-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="class-repeats-label">{{'SCHEDULE.CREATECLASS.CLASSREPEATS' | translate}}</label>
            <div>
              <!-- Input Field -->
              <div *ngIf="!RRuleObject.RRuleText" class="p-input-icon-right w-full text-sm" (click)="showRRule=true"
                aria-label="repeat-input"
                data-testid="repeat-input">
                <div class="p-inputtext p-component p-element cursor-pointer bg-blue-50 w-full">
                  {{'SCHEDULE.CREATEAPPOINTMENT.REPEAT' | translate}}</div>
              </div>
              <div *ngIf="RRuleObject.RRuleText" class="p-input-icon-right w-full text-sm cursor-pointer"
                aria-label="repeat-selected"
                data-testid="repeat-selected">
                <i class="fa fa-times text-xl text-600"
                  (click)="showRRule=false; RRuleObject.RRule =undefined;RRuleObject.RRuleText =undefined;checkStaffAvailability()"
                  aria-label="clear-repeat"
                  data-testid="clear-repeat"></i>
                <div class="p-inputtext p-component p-element w-full" (click)="showRRule=true">{{RRuleObject.RRuleText}}
                </div>
              </div>
              <!-- Input Field -->
            </div>
          </div>

          <div class="col-12 md:col-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="location-label">{{'SCHEDULE.CREATECLASS.CHOOSELOCATION' | translate}}</label>
            <ff-google-places [competitorName]="PlaceNameControl"
              [placeHolderName]="'SCHEDULE.VIEWCLASS.SEARCH_LOCATION' | translate"
              (fetchPlaceInfo)="getPlaceDetails($event)"
              aria-label="location-search"
              data-testid="location-search"></ff-google-places>
          </div>

          <div class="col-12 md:col-8">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="trainer-label">{{'SCHEDULE.CREATECLASS.SELECTTRAINER' | translate}}</label>
            <staff-selector [formGroup]="createClassForm" [controlName]="SelectedTrainerFormControl"
              [styleClass]="'w-full text-sm px-1 py-0 align-items-center'"
              [placeHolder]="'SCHEDULE.CREATEAPPOINTMENT.SELECT' | translate " [filterstaff]="filterStaffIds" (selectedStaff)="onTrainerChange($event)"
              aria-label="trainer-selector"
              data-testid="trainer-selector">
            </staff-selector>
            <app-error-msg *ngIf="SelectedTrainerFormControl.touched && SelectedTrainerFormControl.invalid"
              [errors]="SelectedTrainerFormControl.errors"
              [fieldLabel]="'SCHEDULE.CREATEAPPOINTMENT.LBL_TRAINER' | translate">
            </app-error-msg>

            <div *ngIf="!showSkeleton && !isStaffAvailable" class="-mb-3">
              <p-message severity="error" aria-label="staff-unavailable-message" icon="fa fa-times-circle font-light text-xl" data-testid="staff-unavailable-message">
                <div class="flex align-items-center w-full -my-2">
                    <div class="ml-2 line-height-3 text-sm">
                      <strong>{{ 'STAFF_SCHEDULE.MSG.STAFF_UNAVAILABLE_MSG2' | translate : { name : SelectedTrainerFormControl.value.name } }}
                        <a [routerLink]="['/admin/staff-availability',SelectedTrainerFormControl.value.id]"
                          aria-label="manage-availability-link"
                          data-testid="manage-availability-link">{{ 'STAFF_SCHEDULE.MSG.MANAGE_AVAIL' | translate }}</a>
                        {{ 'STAFF_SCHEDULE.MSG.STAFF_UNAVAILABLE_MSG_1' | translate  }}
                      </strong>
                    </div>
                  </div>
              </p-message>
            </div>
            <p-skeleton *ngIf="showSkeleton" height="2.5rem" styleClass="mt-3" aria-label="loading-skeleton"></p-skeleton>
          </div>

          <div class="col-12">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="class-type-label">{{'SCHEDULE.VIEWCLASS.CLASS_TYPE' | translate}}</label>
            <div class="p-buttonset" aria-label="class-type-buttons">
              <button pButton pRipple icon="fa fa-users" label="{{'SCHEDULE.CREATEAPPOINTMENT.PHYSICAL' | translate}}"
                type="button" class="text-sm border-right-1 border-white" (click)="SetIsVirtual(false)"
                [ngClass]="isVirtal === false ? '' : 'p-button-secondary' "
                aria-label="physical-class-button"
                >
              </button>
              <button pButton pRipple icon="fa fa-video" label="{{'SCHEDULE.CREATEAPPOINTMENT.VIRTUAL' | translate}}"
                type="button" class="text-sm border-right-1 border-white border-1" (click)="SetIsVirtual(true)"
                [ngClass]="isVirtal ? '' : 'p-button-secondary' "
                aria-label="virtual-class-button"
                >
              </button>
            </div>
          </div>

          <div class="col-12">
            <div *ngIf="!isVirtal">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="room-label">{{'SCHEDULE.CREATECLASS.CHOOSEROOM' | translate}}</label>
              <select-room [formGroup]="createClassForm" [controlName]="SelectedRoomFormControl" [tenantId]="tenantId" [styleClass]="'text-sm w-full'" (closeEvent)="closeRoomPupup($event)"
                aria-label="room-selector"
                data-testid="room-selector">
              </select-room>
              <app-error-msg *ngIf="SelectedRoomFormControl.touched && SelectedRoomFormControl.invalid"
                [errors]="SelectedRoomFormControl.errors"
                [fieldLabel]="'SCHEDULE.CREATEAPPOINTMENT.LBL_ROOM' | translate">
              </app-error-msg>
            </div>
            <input *ngIf="isVirtal" type="url" class="w-full text-sm" pInputText formControlName="virtualUrl"
              placeholder="{{'SCHEDULE.CREATEAPPOINTMENT.VIRTUALURL' | translate}}"
              aria-label="virtual-url-input"
               />
          </div>

          <div class="col-12">
            <ul class="list-none md:flex align-items-start flex-wrap p-0 m-0" aria-label="class-settings">
              <li class="flex align-items-center my-2 md:w-4">
                <p-toggleSwitch formControlName="isDropInAllowed"
                  aria-label="drop-in-allowed-switch"
                 ></p-toggleSwitch>
                <span class="ml-3">{{'SCHEDULE.CREATECLASS.DROPINALLOWED' | translate}}</span>
              </li>
              <li class="flex my-2 md:w-4" [ngClass]="showMaxCapacityInput ? '' : 'align-items-center' ">
                <p-toggleSwitch (onChange)="toggleMaxCapacity($event.checked)"
                  aria-label="limit-capacity-switch"
                  ></p-toggleSwitch>
                <div class="ml-3">
                  <div>{{'SCHEDULE.CREATECLASS.LIMITCAPACITYINFO' | translate}}</div>
                  <!-- <p-inputNumber *ngIf="showMaxCapacityInput" formControlName="maxCapacity" mode="decimal"
                    class="w-full md:w-12rem text-sm mt-2"
                    placeholder="{{'SCHEDULE.CREATECLASS.LIMIT_IN_NUMBER' | translate}}" [format]="false">
                  </p-inputNumber> -->
                  <app-input-number *ngIf="showMaxCapacityInput" [formGroup]="createClassForm" [controlName]="MaxCapacityFormControl" [placeholder]="'SCHEDULE.CREATECLASS.LIMIT_IN_NUMBER' | translate" 
                     [styleClass]="'w-full md:w-12rem text-sm mt-2'" [conditionToFormat]="false" [mode]="'number'"
                     aria-label="max-capacity-input"
                     >
                   </app-input-number>
                  <app-error-msg *ngIf="MaxCapacityFormControl.touched && MaxCapacityFormControl.invalid"
                    [errors]="MaxCapacityFormControl.errors"
                    [fieldLabel]="'SCHEDULE.CREATECLASS.LBL_MAXCAPACITY' | translate">
                  </app-error-msg>
                </div>
              </li>
              <li class="flex my-2 md:w-4" [ngClass]="showMaxWaitlistInput ? '' : 'align-items-center' ">
                <p-toggleSwitch (onChange)="toggleMaxWaitlist($event.checked)"
                  aria-label="limit-waitlist-switch"
                  ></p-toggleSwitch>
                <div class="ml-3">
                  <div>{{'SCHEDULE.CREATECLASS.LIMITWAITLISTINFO' | translate}}</div>
                  <!-- <p-inputNumber *ngIf="showMaxWaitlistInput" mode="decimal" formControlName="maxWaitlist"
                    class="w-full md:w-12rem text-sm mt-2"
                    placeholder="{{'SCHEDULE.CREATECLASS.WAITLIST_IN_NUMBER' | translate}}" [format]="false">
                  </p-inputNumber> -->

                  <app-input-number *ngIf="showMaxWaitlistInput" [formGroup]="createClassForm" [controlName]="MaxWaitListFormControl" [placeholder]="'SCHEDULE.CREATECLASS.WAITLIST_IN_NUMBER' | translate" 
                  [styleClass]="'w-full md:w-12rem text-sm mt-2'" [conditionToFormat]="false" [mode]="'number'"
                  aria-label="max-waitlist-input"
                  >
                </app-input-number>

                  <app-error-msg *ngIf="MaxWaitListFormControl.touched && MaxWaitListFormControl.invalid"
                    [errors]="MaxWaitListFormControl.errors"
                    [fieldLabel]="'SCHEDULE.CREATECLASS.LBL_MAXWAITLIST' | translate">
                  </app-error-msg>
                </div>
              </li>
              <li class="flex align-items-center my-2 md:w-6" *ngIf="selectedClassType && selectedClassType.allows_trial">
                <p-toggleSwitch formControlName="accepts_trial"
                  aria-label="accept-trials-switch"
                  ></p-toggleSwitch>
                <span class="ml-3">{{'SCHEDULE.CREATECLASS.ACCEPT_TRIALS' | translate}}
                </span>
              </li>
            </ul>

            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-0">

          </div>

          <div class="col-12">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="comments-label">{{'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate}}</label>
            <textarea placeholder="{{'SCHEDULE.CREATECLASS.ADDCOMMENTS' | translate}}" formControlName="comments"
              pInputText class="w-full text-sm h-5rem"
              aria-label="comments-textarea"
              ></textarea>
          </div>

        </div>

        <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-0">

        <div class="flex align-items-center justify-content-between p-3">
          <button pButton type="button" label="{{'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate}}" (click)="GoToFitnessCalendar()" class="text-sm p-button-text"
            aria-label="cancel-button"
            ></button>
          <p-confirmPopup key="bookconfirm"></p-confirmPopup>
          <button pButton type="button" label="{{'SCHEDULE.CREATECLASS.CREATE_REP_CLASS_BTN' | translate}}" [disabled]="disableSaveBtn" [loading]="disableSaveBtn"
            class="text-sm" (click)="isStaffAvailable ? CreateClass(createClassForm) : confirm($event)"
            aria-label="create-class-button"
            >
          </button>
        </div>
        <!-- Card -->

      </div>
      <!-- Card -->

      <!-- Body Content-->
    </form>
    </div>
  <!-- Body Content-->

  <rrule *ngIf="showRRule" [visible]="showRRule" [showNeverStop]="true" [minimumDate]="minimumDate" [rRuleObj]="RRuleObject"
    (hideRrule)="HideRRule($event)" (emitRRule)="FetchRRuleData($event)"
    aria-label="recurrence-rule-dialog"
    data-testid="recurrence-rule-dialog">
  </rrule>

  <app-errors *ngIf="showErrorPopup$ | async as showPopup" [error]="error" [visible]="showPopup"
    [errorData]="errorMessages" (hideErrorPopup)="HideErrorPopup($event)"
    aria-label="error-dialog"
    data-testid="error-dialog">
  </app-errors>

